import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGroup, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { PhotoService } from '../services/photo.service';
import { Photo } from '../../../shared/models/cameralla-photo.model';
import { CategoryService } from '../../category/services/category.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import * as $ from 'jquery';
import { Observable, of } from 'rxjs';
import { GlobalVariables } from '../../../shared/models/cameralla-global.model';
import { TagInputComponent } from "ngx-chips";
import { CamerallaUser } from "../../../shared/models/cameralla-user.model";
import { UserService } from "../../user/services/user.service";
import { CamerallaAuthService } from "../../../shared/services/authentication-services/cameralla-auth.service";
import { MapPopupComponent } from "../../upload/components/map-popup/map-popup.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GeoLocationService } from "../../../shared/services/geo-location.service";
import { UploadService } from "../../upload/service/upload.service";
import { PermissionAdminService } from "../../../shared/services/guard-services/permission-admin.service";
import { LocationService } from "../../../shared/services/location.service";
import * as L from 'leaflet';

@Component({
    selector: 'app-photo-edit',
    templateUrl: './edit.component.html',
    providers: [GeoLocationService]
})
export class PhotoEditComponent implements OnInit {
    @ViewChild('inputTag')
    inputTag: TagInputComponent;
    public photo: Photo;
    public photoRelated: Photo;
    public onUpdating = false;
    public action;
    public photoId;
    public categories: any[];
    public category;
    public location = null;
    public locationModel: any = {};
    public original: string;
    public formData: FormData;
    public formDataRelated: FormData;
    private sub: any;
    public onLoaded = false;
    public tags = [];
    formValid = true;
    form = new FormGroup({});
    maxLength = 1000;
    partnerNavigators = GlobalVariables.partnerNavigators;
    tagCollection = GlobalVariables.tag_collection;
    partnerObjects = GlobalVariables.partnerObjects;
    additionClubType = GlobalVariables.additionalClubType;
    userProfile: CamerallaUser;
    localUserId;
    loaded = false;
    tagLoaded = false;
    wasRelated = "";
    isAdmin = false;
    removePhotoRelated = false;
    showApplyForLocation;
    isApplyForLocation;
    lat;
    lng;
    fileRelated: File;
    map;



    constructor(private authService: CamerallaAuthService,
                private router: Router,
                private http: HttpClient,
                private route: ActivatedRoute,
                private toastr: ToastrService,
                private photoService: PhotoService,
                private uploadService: UploadService,
                private categoryService: CategoryService,
                private modalService: NgbModal,
                private geoLocationService: GeoLocationService,
                private locationService: LocationService,
                private userService: UserService) {
        this.photo = new Photo();
        this.action = this.route.snapshot.paramMap.get('action');
        this.localUserId = +this.authService.getLocalUserInfo()['id'];
    }

    ngOnInit() {
        this.partnerNavigators.push(...this.additionClubType);
        this.userService.getUserInformation(this.localUserId).then(
            (resolve: any[]) => {
                this.isAdmin = (resolve[0].role == PermissionAdminService.adminConst);
                this.userProfile = Object.assign(resolve[0], resolve[1]);
                this.loaded = true;

                this.sub = this.route.params.subscribe(params => {
                    if (params['id']) {
                        this.photoId = params['id'];
                        this.initEditableValue();
                    } else {
                        this.toastr.error('Photo ID missing!', 'Something wrong');
                    }
                });
            }
        );
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const element = document.querySelector("main section.wrapper");
            element.classList.add('custom-wrapper');
        }, 500)
    }

    ngOnDestroy() {
        const element = document.querySelector("main section.wrapper");
        element.classList.remove('custom-wrapper');
    }

    initEditableValue() {
        this.categoryService.getCategories().toPromise().then(
            response => {
                this.categories = response['Data'];
                this.getPhotoDetails(this.photoId);
            },
            error => {
                console.log('getCategories error ' + error);
            }
        );

    }

    getPhotoDetails(id) {
        this.photoService.getPhotoDetails(id, false).then(
            response => {
                this.photo = response['Data'];

                if (this.photo.customerId != this.localUserId && !this.isAdmin) {
                    this.router.navigate(['/']);
                }

                this.showApplyForLocation = this.photo.category.categoryType === 'location';

                if (this.photo.locationId) {
                    this.locationService.getLocationDetail(this.photo.locationId).toPromise().then((location: any) => {
                        if (location.Data) {
                            this.lat = location.Data.lat;
                            this.lng = location.Data.lng;
                            this.locationModel = location.Data;
                            this.initMap(this.lat, this.lng);
                        }
                    })
                }

                this.tags = this.photoService.getTags(this.photo.tags);
                // Get photo related url
                if (response['Data'] && response['Data']['photoRelated']) {
                    this.photoService.getPhotoDetails(response['Data']['photoRelated'], false, this.localUserId).then(res => {
                        if (res['IsSuccess'] && res['Data'] && res['Data']['thumbnail']) {
                            this.photoRelated = res['Data'];
                        }
                    })
                }

                // Hide default tags
                // this.tagCollection.forEach(tag => {
                //     var tagPosition = this.tags.indexOf(tag.value);
                //     if (tagPosition !== -1) this.tags.splice(tagPosition, 1);
                // });

                this.userService.getUserInformation(this.photo.customerId, true).then(
                    (resolve: any[]) => {
                        this.userProfile = Object.assign(resolve[0], resolve[1]);
                        this.tags = this.tags.filter(item => this.userProfile.memberships.indexOf(item) < 0);
                        this.tagLoaded = true;

                        this.addAddTagBtn();
                    }
                );

                this.onLoaded = true;
            },
            error => {
                console.log('getPhotoDetails error ' + error);
            }
        );
    }

    public addAddTagBtn() {
        setTimeout(() => {
            $("tag-input-form").append(' <button (click)="addTag()" id="button-add-tag" class="btn btn-tag btn-primary text-white">Add</button>');

            $("#button-add-tag").click(() => {
                if (this.inputTag.inputTextValue) {
                    this.inputTag.items.push((this.inputTag.inputTextValue));
                    this.inputTag.inputTextValue = '';
                }
            });
        })
    }

    selectCategory(category, subCategory?) {
        if (this.photo.locationId && category.categoryType !== 'location') {
            this.toastr.error('You only can switch to Landscape or Urban landscape, ' +
                'because this photo already linked with a location', 'ERROR');

            return;
        }

        this.showApplyForLocation = category.categoryType === 'location';

        this.photo.category = category;
        this.photo.categoryId = category.id;

        if (subCategory) {
            this.photo.subCategory = subCategory;
            this.photo.subCategoryId = subCategory.id;
        } else {
            this.photo.subCategory = {};
            this.photo.subCategoryId = null;
        }
    }

    selectPartner(partner) {
        this.photo.partner = partner;
    }

    edit(f: NgForm) {
        if (f.valid) {
            this.formValid = true;
            this.formData = new FormData();
            this.formData.append('id', '' + this.photo.id);
            this.formData.append('location', this.location ? this.location : 'Unknown');
            if (this.removePhotoRelated) {
                this.formData.append('photoRelated', '');
            }
            this.formData.append('lng', this.lng);
            this.formData.append('lat', this.lat);
            if (this.photo.traceLog) {
                if  (this.photo.traceLog.length >= 50) {
                    this.photo.traceLog = this.photo.traceLog.substring(1);
                }
                this.photo.traceLog = this.photo.traceLog + '2';
            } else {
                this.photo.traceLog = "2";
            }
            this.formData.append('traceLog', this.photo.traceLog);

            if (f.value.tags) {
                f.value.tags = f.value.tags.map(tag => tag.replace(/[^?!-øæå\w\s]/gi, ''));
            }

            // if (this.userProfile && this.userProfile.memberships.length > 0) {
            //     f.value.tags.push(...this.userProfile.memberships);
            // }

            if (this.fileRelated && this.fileRelated.name) {
                this.formDataRelated = new FormData();
                this.formDataRelated.set('customerId', this.localUserId);
                this.formDataRelated.set('photo', this.fileRelated, this.fileRelated.name);
                this.formDataRelated.set('title', this.fileRelated.name);
                this.formDataRelated.set('wasRelated', this.wasRelated);
            }

            for (const key in f.value) {
                if (f.value.hasOwnProperty(key)) {
                    // f.value[key] = this.checkExifEmpty(key, f.value[key]);
                    // this.formData.append(key, f.value[key]);

                    if (f.value[key] && f.value[key].length > this.maxLength) {
                        this.formValid = false;
                    } else {
                        if (key === 'title' && !f.value[key]) {
                            this.formData.append(key, 'Untitled');
                        } else {
                            this.formData.append(key, f.value[key]);
                        }
                    }
                }
            }

            if (this.formValid) {
                let createLocationObs = of({});

                if ((this.photo.isPrimaryLocation && this.photo.locationId) ||
                    (this.isApplyForLocation && !this.photo.locationId)
                ) { // add location to photo
                    if (this.lat && this.lng && this.locationModel.address) {
                        this.onUpdating = true;
                        const params = {
                            address: this.locationModel.address,
                            partnerId: f.value.partnerId,
                            lat: this.lat,
                            subCategoryId:  this.photo.subCategoryId,
                            locationUrl:  this.locationModel.locationUrl,
                            categoryId: this.photo.categoryId,
                            lng: this.lng,
                            description: f.value.locationDescription,
                            groupId: this.photo.groupId
                        }

                        if (this.photo.locationId) {
                            createLocationObs = this.locationService.updateLocation(this.photo.locationId, params);
                        } else {
                            createLocationObs = this.locationService.createLocation(params);
                        }

                    } else {
                        this.toastr.error('Please pin the location on the map', 'UPLOAD FAILED');
                        return;
                    }
                }

                createLocationObs.subscribe((location: any) => {
                    if (location.Data && location.Data.id && !this.photo.locationId) {
                        this.formData.append('locationId', location.Data.id);
                        this.formData.append('isPrimaryLocation', "true");
                    }

                    this.uploadService.upload(this.formData, this.formDataRelated, null, true);
                }, error => {
                    this.toastr.error('Check your input and try again.', 'UPLOAD FAILED');
                })
            } else {
                this.toastr.error('Check your input and try again.', 'EDIT FAILED');
                return setTimeout(() => {
                    const offset_top = $('.text-danger:first').offset().top - $('main').offset().top + $('main').scrollTop() - 50;
                    $('html, body').animate({scrollTop: offset_top}, 'slow');
                }, 0);
            }
        } else {
            this.formValid = false;
        }
    }

    checkExifEmpty(key, value) {
        switch (key) {
            case 'model':
                if (!value) {
                    return 'Canon EOS 1D X Mark II';
                }
                return value;
            case 'lens':
                if (!value) {
                    return '50mm F1.8';
                }
                return value;
            case 'focalLength':
                if (!value) {
                    return '24';
                }
                return value;
            case 'aperture':
                if (!value) {
                    return '2.2';
                }
                return value;
            case 'ISO':
                if (!value) {
                    return '300';
                }
                return value;
            case 'shutterSpeed':
                if (!value) {
                    return '1/1600';
                }
                return value;
            default:
                return value;
        }
    }

    public onAdding(tag: string): Observable<any> {
        return of(tag.toLocaleLowerCase());
    }

    public addTag() {
        if (this.inputTag.inputTextValue) {
            this.inputTag.items.push((this.inputTag.inputTextValue));
            this.inputTag.inputTextValue = '';
        }
    }

    openMap() {
        const modalRef = this.modalService.open(MapPopupComponent, {backdrop: 'static', windowClass: 'map-modal'});
        modalRef.componentInstance.lat = this.lat ? this.lat : this.photo.exif.lat;
        modalRef.componentInstance.lng = this.lng ? this.lng : this.photo.exif.lng;
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            if (receivedEntry.address) {
                this.lat = receivedEntry.lat;
                this.lng = receivedEntry.lng;
                this.initMap(this.lat, this.lng);
            }
        })
    }

    getPhotoRelated(file) {
        if (file.remove) {
            this.removePhotoRelated = true;
            file = {};
        } else {
            this.removePhotoRelated = false;
        }

        this.fileRelated = file;
        if (file.wasRelated) {
            this.wasRelated = file.wasRelated;
        }
    }

    public initMap(lat, lng, zoom = 16) {
        // refresh map id
        document.getElementById(
            "map-preview"
        ).innerHTML = `<div id='map-content-preview' style='width: 100%; height: 100%;'></div>`;

        this.map = L.map("map-content-preview", {
            center: [lat, lng],
            // Set the initial zoom level, values 0-18, where 0 is most zoomed-out (required)
            zoom: zoom,
            preferCanvas: true
        });

        L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
            maxZoom: 20,
            subdomains:['mt0','mt1','mt2','mt3']
        }).addTo(this.map);


        L.marker([lat, lng], {icon: L.icon({
                iconUrl: './assets/images/location-pin.png',
                iconSize: [40, 40], // size of the icon
                popupAnchor: [0, -15] // point from which the popup should open relative to the iconAnchor
            })})
            .addTo(this.map)


        //handle click event
        this.map.on('click', e => {
            this.openMap();
        });
    }
}
